module.exports = {"data":{"site":{"siteMetadata":{"title":"Razy Technologies"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/projects/bluetooth-printers-distribution/"},"frontmatter":{"title":"Bluetooth Printers Distribution"}}}]}},"pathContext":{"tag":"pos"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-pos.json
// module id = 471
// module chunks = 246880939828482